<template>
<div class="chapter">
<div class="inner_page">
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p3"><span class="sz"><i>The Death of Nnanji</i></span></p>
<p class="p3"><span class="sz">is dedicated to</span></p>
<p class="p4"><span class="sz"> </span></p>
<p class="p1"><span class="sz">Richard Curtis, who has been my agent for more than twenty years, who carefully recovered all the rights when any of my books went out of print, who pioneered the e-book ahead of almost everyone else, who made all those out-of-print books available once again, who has now become my publisher, and who, in short, has been my steadfast companion in journeys through many strange worlds.</span></p>
<p class="p2"><span class="sz"><b></b> </span></p>
<p class="p2"><span class="sz"><b></b> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section3.vue?61460c5c